export const formatDateForAPI = (dateString) => {
  if (!dateString) {
    return "";
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return dateString;
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const convertPeriodToDate = (period) => {
  if (!period) {
    return "";
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(period)) {
    return period;
  }

  if (/^\d{4}-\d{2}$/.test(period)) {
    const [year, month] = period.split("-").map(Number);
    const lastDay = new Date(year, month, 0).getDate();

    return `${year}-${String(month).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
  }

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const lastDay = new Date(year, month, 0).getDate();

  return `${year}-${String(month).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
};

export const getLastDayOfMonth = (period) => {
  if (!period) {
    return "";
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(period)) {
    const [year, month] = period.split("-").map(Number);
    const lastDay = new Date(year, month, 0).getDate();
    return `${year}-${String(month).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
  }

  if (/^\d{4}-\d{2}$/.test(period)) {
    return convertPeriodToDate(period);
  }

  return period;
};

export const getFirstDayOfMonth = (period) => {
  if (!period) {
    return "";
  }

  if (/^\d{4}-\d{2}$/.test(period) || /^\d{4}-\d{2}-\d{2}$/.test(period)) {
    const [year, month] = period.split("-");
    return `${year}-${month}-01`;
  }

  return period;
};

export const getRangeStartDate = (period) => {
  if (!period) {
    return "";
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(period)) {
    return period;
  }

  return getFirstDayOfMonth(period);
};

export const getRangeEndDate = (period) => {
  if (!period) {
    return "";
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(period)) {
    return period;
  }

  return getLastDayOfMonth(period);
};

export const resolveReportDates = (filters = {}) => {
  const isRange = Boolean(filters.periodFrom && filters.periodTo);
  const singlePeriod = filters.period || "";

  return {
    isRange,
    balanceDate: getLastDayOfMonth(isRange ? filters.periodTo : singlePeriod),
    rangeStartDate: isRange ? getRangeStartDate(filters.periodFrom) : getFirstDayOfMonth(singlePeriod),
    rangeEndDate: isRange ? getRangeEndDate(filters.periodTo) : getRangeEndDate(singlePeriod),
  };
};
